<form class="" [formGroup]="formUsuario" id="formUsuarioId">
  <div class="modal-container">
    <svg class="icon-close" mat-dialog-close>
      <use xlink:href="#icon-close"></use>
    </svg>
    <h1>{{tituloModal}}</h1>
    <div *ngIf="!nuevo && info.datosUsuario.usuarioActivo" class="estado-activo">{{estado}}</div>
    <div *ngIf="!nuevo && !info.datosUsuario.usuarioActivo && !info.datosUsuario.invitacionEnviada && !info.datosUsuario.invitacionAceptada" class="estado-inactivo">Desactivado</div>
    <div *ngIf="!nuevo && !info.datosUsuario.usuarioActivo && info.datosUsuario.invitacionEnviada && !info.datosUsuario.invitacionAceptada" class="estado-pendiente">Pendiente activación</div>
    <div class="flex-container">
      <div [ngClass]="nuevo ? 'modal-content-nuevo':'modal-content-usuario'">
        <span class="input-text-custom">
          <label for="nombreUsuario">Nombre</label>
          <div *ngIf="!isEditar && !nuevo" class="info" id="nombreUsuario">{{nombreUsuario.value}}</div>
          <input *ngIf="isEditar || nuevo"
                  type="text"
                  id="nombreUsuario"
                  name="nombreUsuario"
                  formControlName="nombreUsuario"
                  [ngClass]="{'errorInput': isCampoValido('nombreUsuario')}"
              />
          <span class="texto-validacion"
                  *ngIf="isCampoValido('nombreUsuario')">
                  El nombre del usuario es requerido.
          </span>
        </span>
        <span class="input-text-custom">
          <label for="apellidosUsuario">Apellidos</label>
          <div *ngIf="!isEditar && !nuevo" class="info" id="apellidoUsuario">{{apellidosUsuario.value}}</div>
          <input *ngIf="isEditar || nuevo"
                  type="text"
                  id="apellidosUsuario"
                  name="apellidosUsuario"
                  formControlName="apellidosUsuario"
                  [ngClass]="{'errorInput': isCampoValido('apellidosUsuario')}"
              />
          <span class="texto-validacion"
                  *ngIf="isCampoValido('apellidosUsuario')">
                  Los apellidos del usuario son requeridos.
          </span>
        </span>
        <span *ngIf="nuevo" class="input-text-custom">
          <label for="emailUsuario">Email</label>
          <input  type="text"
                  id="emailUsuario"
                  name="emailUsuario"
                  formControlName="emailUsuario"
                  [ngClass]="{'errorInput': isCampoValido('emailUsuario')}"/>
          <span class="texto-validacion"
                  *ngIf="isCampoValido('emailUsuario')">
                  El email del usuario es requerido y tiene que tener formato de email.
          </span>
        </span>
        <span *ngIf="!nuevo" class="input-text-custom">
          <label for="emailUsuario">Login</label>
          <div class="info" id="loginUsuario">{{emailUsuario.value}}</div>
        </span>
        <span *ngIf="datosUsuariosService.integracionA3 && !nuevo" class="input-text-custom">
          <label for="usuarioA3Trans">Usuario A3</label>
          <div *ngIf="!isEditar && !nuevo" class="info" id="usuarioA3Trans">{{usuarioA3Trans.value}}</div>
          <input *ngIf="isEditar || nuevo"
                  type="text"
                  id="usuarioA3Trans"
                  name="usuarioA3Trans"
                  formControlName="usuarioA3Trans"/>
        </span>
        <span *ngIf="datosUsuariosService.integracionA3 && !nuevo" class="input-text-custom">
          <label for="passwordA3">Password A3</label>
          <div *ngIf="!isEditar && !nuevo" class="info" id="passwordA3">{{getMaskedPassword(passwordA3.value)}}</div>
          <div class="password-container">
            <input *ngIf="isEditar || nuevo"
                    [type]="hidePassword ? 'password' : 'text'"
                    id="passwordA3"
                    name="passwordA3"
                    formControlName="passwordA3"
                    autocomplete="new-password"
                    [ngClass]="{'errorInput': isCampoValido('passwordA3')}"
                />
            <i *ngIf="isEditar || nuevo"
               class="fa"
               [ngClass]="hidePassword ? 'fa-eye-slash' : 'fa-eye'"
               (click)="togglePasswordVisibility()"></i>
          </div>

          <span class="texto-validacion"
                  *ngIf="isCampoValido('passwordA3')">
                  El password no debe contener más de 25 caracteres.
          </span>
        </span>
        <span class="input-text-custom">
          <label for="rolUsuario">Rol</label>
          <div *ngIf="!isEditar && !nuevo" class="info" id="rolUsuario">{{rolUsuario.value}}</div>
          <select *ngIf="isEditar || nuevo"
                  (change)="cambiarRol($event)"
                  id="rolUsuario"
                  formControlName="rolUsuario"
                  [ngClass]="{'errorInput': isCampoValido('rolUsuario')}">
          <option *ngFor="let usuario of usuarioTipos" [value]="usuario">
            {{ usuario }}
          </option>
        </select>
        <span class="texto-validacion"
              *ngIf="isCampoValido('rolUsuario')">
              El rol es requerido.
        </span>
        <!-- <div class="grey-subtitulo">
          <div *ngFor="let permiso of usuarioPermisos">
            <p class="capital">{{permiso.tituloPermisos}}</p>
            <ul>
              <li *ngFor="let perm of permiso.permisos">
                <svg class="icon-check">
                  <use attr.xlink:href="{{iconPermisos}}"></use>
                </svg>
                {{perm}}
              </li>

            </ul>
          </div>

        </div> -->

        </span>
        <span class="input-text-custom">
          <label for="tieneMfa" class="mfa-title">
            <svg class="mfa-title-icon">
              <use xlink:href="#icon-security"></use>
            </svg>
            <span>Doble factor de autenticación</span>
          </label>
          <div *ngIf="!isEditar && !nuevo" class="info mfa-status" id="tieneMfa">
            <span class="mfa-status-dot" [ngClass]="mfaStatusClass"></span>
            <span>{{activadoMfa}}</span>
          </div>
          <div *ngIf="isEditar || nuevo" class="mfa-selector">
            <app-selector [textoOpcion1]="''" [textoOpcion2]="mfaActivo ? 'Activado' : 'Desactivado'" [active]="mfaActivo" [colorSelector]="'#3FA677'" (mostrarSeleccion)="checkSiTenants($event)"></app-selector>
          </div>

        </span>
        <div *ngIf="(isEditar || nuevo) && rolUsuario.value == 'Usuario'">
          <h6 id="seguridadFirmas">Seguridad firmas</h6>
          <span class="input-text-custom">
            <label for="seguridadUsuario">Tipo seguridad</label>
            <select (change)="cambiarSeguridad($event)"
                    id="seguridadUsuario"
                    formControlName="seguridadUsuario"
                    [ngClass]="{'errorInput': isCampoValido('seguridadUsuario')}"
                    >
              <option *ngFor="let usuario of usuarioSeguridad" [value]="usuario.id">
                {{ usuario.desc }}
              </option>
            </select>
            <span class="texto-validacion"
                  *ngIf="isCampoValido('seguridadUsuario')">
                  El tipo de seguridad es requerida si el rol es "Usuario".
            </span>
          </span>
          <mat-spinner *ngIf="seguridadTipoActual && (mostrarLink || mostrarLinkCentroDosier) && !isSeguridadDataReady" diameter="30" strokeWidth="2" style="margin: auto; margin-top: 100px;"></mat-spinner>
          <div *ngIf="seguridadTipoActual && (mostrarLink || mostrarLinkCentroDosier) && isSeguridadDataReady">
            <p *ngIf="mostrarLink && !mostrarLinkCentroDosier" class="link-seguridad" (click)="abreModalSeguridad(seguridadUsuario.value)">{{seleccionarSeguridad}}</p>
            <p *ngIf="mostrarLinkCentroDosier" class="link-seguridad" (click)="abreModalSeguridad(seguridadUsuario.value, 'Centro')">{{seleccionarSeguridadCentro}}</p>
            <p *ngIf="mostrarLinkCentroDosier" class="link-seguridad" (click)="abreModalSeguridad(seguridadUsuario.value,'TipoEnvio')">{{seleccionarSeguridadDosier}}</p>
            <span *ngIf="errorMessage.length>0" class="texto-validacion" style="margin-left: -5px;">{{errorMessage}}</span>
          </div>

        </div>
      </div>
      <div class="modal-buttons">
          <app-boton-accion mat-dialog-close
                        *ngIf="!isEditar && isCerrar"
                        [icono]="'icon-close'"
                        [titulo]="'Cerrar'"
                        [id]="'Cerrar'"
                        [outline]="true"
                        [cancelar]="false">
          </app-boton-accion>
          <app-boton-accion
                        *ngIf="isDesactivar && !isEditar"
                        (botonClicked)="desactivarUsuario()"
                        [icono]="'hs-activar'"
                        [titulo]="'Desactivar'"
                        [id]="'Desactivar'"
                        >
          </app-boton-accion>
          <!-- <app-boton-accion mat-dialog-close
                            *ngIf="isEditar && !isActivar && !isSoloSwitch"
                            [icono]="'icon-close'"
                            [titulo]="'Cancelar'"
                            [id]="'Cancelar'"
                            [outline]="true"
                            [cancelar]="true">
          </app-boton-accion> -->
          <app-boton-accion mat-dialog-close
                            *ngIf="isEditar"
                            [icono]="'icon-close'"
                            [titulo]="'Cancelar'"
                            [id]="'Cancelar'"
                            [outline]="true"
                            [cancelar]="true">
          </app-boton-accion>


          <!-- <app-boton-accion *ngIf="isEditar && !isActivar && !isSoloSwitch"
                            (botonClicked)="guardarUsuario()"
                            [icono]="'hs-download'"
                            [titulo]="'Guardar'"
                            [id]="'Guardar'">
          </app-boton-accion> -->
          <app-boton-accion *ngIf="!nuevo && isEditar"
                            (botonClicked)="guardarUsuario(info.datosUsuario)"
                            [icono]="'hs-guardar'"
                            [titulo]="'Guardar'"
                            [id]="'Guardar'">
          </app-boton-accion>
          <app-boton-accion *ngIf="!nuevo && isActivar"
                            (botonClicked)="activarUsuario()"
                            [icono]="'hs-activar'"
                            [titulo]="'Activar'"
                            [id]="'Activar'">
          </app-boton-accion>
          <app-boton-accion *ngIf="!info.datosUsuario.usuarioActivo && info.datosUsuario.invitacionEnviada && !info.datosUsuario.invitacionAceptada && !isEditar"
                            (botonClicked)="eliminarUsuario()"
                            [icono]="''"
                            [titulo]="'Eliminar Usuario'"
                            [id]="'Eliminar Usuario'"
                            [outline]="true"
                            [cancelar]="true">
          </app-boton-accion>
          <app-boton-accion *ngIf="!nuevo && !info.datosUsuario.usuarioActivo && info.datosUsuario.invitacionEnviada && !info.datosUsuario.invitacionAceptada && !isEditar"
                            (botonClicked)="reInvitarUsuario()"
                            [icono]="''"
                            [titulo]="'Reenviar invitación'"
                            [id]="'Reenviar invitacion'"
                            [outline]="true"
                            [cancelar]="true">
          </app-boton-accion>
          <app-boton-accion *ngIf="!nuevo && !isEditar && !isCerrar"
                            (botonClicked)="editarUsuario()"
                            [icono]="'hs-edit'"
                            [titulo]="'Editar'"
                            [id]="'Editar'">
          </app-boton-accion>
          <app-boton-accion *ngIf="nuevo"
                            mat-dialog-close
                            [titulo]="'Cancelar'"
                            [id]="'Cancelar'"
                            [outline]="true"
                            [cancelar]="true">
          </app-boton-accion>
          <app-boton-accion *ngIf="nuevo"
                            (botonClicked)="invitarUsuario()"
                            [titulo]="'Invitar'"
                            [id]="'Invitar'">
          </app-boton-accion>
      </div>
    </div>
  </div>
</form>
